import apiClient from "../../../service/apiClient";
import { ADMIN_PANEL_ENDPOINTS } from "../../../app/apiEndpoints";


export const getAdminGridData = (userid) => {
  return apiClient.get(ADMIN_PANEL_ENDPOINTS.GET_ADMIN_USERS,{params:{userId:userid}})
}

export const getUsersWithUserName = (username) => {
  return apiClient.get(ADMIN_PANEL_ENDPOINTS.GET_UNLOCKED_USERS+`/${username}`)
}

export const updateLoginAttempts = (data) => {
    return apiClient.post(ADMIN_PANEL_ENDPOINTS.UPDATE_LOGIN_ATTEMPTS,data)
}

export const getLockedUsers = () => {
    return apiClient.get(ADMIN_PANEL_ENDPOINTS.GET_LOCKED_USERS)
}

export const getSystemSettings = () => {
    return apiClient.get(ADMIN_PANEL_ENDPOINTS.GET_SYSTEM_SETTINGS);
}

export const updateSystemSettings =(data) => {
    return apiClient.post(ADMIN_PANEL_ENDPOINTS.UPDATE_SYSTEM_SETTINGS,data);
}

export const insertAdmin = (data) => {
    return apiClient.post(ADMIN_PANEL_ENDPOINTS.INSERT_ADMIN_USER,data)
}

export const updateAdmin = (data) => {
    return apiClient.post(ADMIN_PANEL_ENDPOINTS.UPDATE_ADMIN_USER, data)
}

export const deleteUser = (data) => {
    return apiClient.post(ADMIN_PANEL_ENDPOINTS.DELETE_USER,data)
}

export const resetAuthKey = (data) => {
    return apiClient.post(ADMIN_PANEL_ENDPOINTS.RESET_USER_MFA,data)
}

export const getSecurityQuestions = () => {
    return apiClient.get(ADMIN_PANEL_ENDPOINTS.GET_SECURITY_QUESTIONS)
}

export const getSecurityAnswers = (userid, challengephraseanswerid) => {
    return apiClient.get(ADMIN_PANEL_ENDPOINTS.GET_SECURITY_ANSWERS, {params:{userId:userid, challengePhraseAnswerId:challengephraseanswerid}})
}

export const insertSecurityQuestion = (data) => {
    return apiClient.post(ADMIN_PANEL_ENDPOINTS.INSERT_OR_UPDATE_SECURITY_QUESTION,data)
}

export const insertSecurityAnswer = (data) => {
    return apiClient.post(ADMIN_PANEL_ENDPOINTS.INSERT_OR_UPDATE_SECURITY_ANSWER, data)
}

export const getUserFailedLoginAttempts = (fromdate, todate) => {
    return apiClient.get(ADMIN_PANEL_ENDPOINTS.GET_USER_LOGIN_ATTEMPTS,
        {params:{
            fromDate:fromdate,
            toDate: todate,
            isSuccess: false
        }})
}

export const getUserSuccessLoginAttempts = (fromdate, todate) => {
    return apiClient.get(ADMIN_PANEL_ENDPOINTS.GET_USER_LOGIN_ATTEMPTS,
        {params:{
            fromDate:fromdate,
            toDate: todate,
            isSuccess: true
        }})
}

export const getUserActiveSessions = (fromdate, todate) => {
    return apiClient.get(ADMIN_PANEL_ENDPOINTS.GET_USER_ACTIVE_SESSIONS,
        {params:{
            fromDate:fromdate,
            toDate: todate
        }})
}

export const getUserLoginByIPDetail = (fromdate, todate) => {
    return apiClient.get(ADMIN_PANEL_ENDPOINTS.GET_USER_LOGINS_BY_IP_DETAILS,
        {params:{
            fromDate:fromdate,
            toDate: todate
        }})
}

export const getUserLoginByIPSummary = (fromdate, todate) => {
    return apiClient.get(ADMIN_PANEL_ENDPOINTS.GET_USER_LOGINS_BY_IP_SUMMARY,
        {params:{
            fromDate:fromdate,
            toDate: todate
        }})
}

export const getUserPasswordResetActivities = (fromdate, todate) => {
    return apiClient.get(ADMIN_PANEL_ENDPOINTS.GET_USER_PASSWORD_RESET_ACTIVITIES,
        {params:{
            fromDate:fromdate,
            toDate: todate
        }})
}

export const getActiveUsers = () => {
    return apiClient.get(ADMIN_PANEL_ENDPOINTS.GET_ACTIVE_USERS)
}

export const getUsersPageTrackingDetails = (userid, contactid, fromdate, todate) => {
    return apiClient.get(ADMIN_PANEL_ENDPOINTS.GET_PAGE_TRACKING_DETAILS,
        {params:{
            userId: userid,
            contactId: contactid,
            fromDate:fromdate,
            toDate: todate
        }}
    )
}